import { enumKeysToArray } from '@/utils/enum'
import { makeServicesTypes } from '@/core/container/makeServicesTypes'

enum SERVICES {
  StripoEditorService,
  TemplateStripoEmailFormService,
  StripoTokenRepository,
  StripoTokenService,
  StripoTemplateTypeRepository,
  StripoApiTransport,
  StripoPrebuiltTemplateRepository,
  StripoPrebuiltTemplatesColumnServiceFactory,
  StripoPrebuiltTemplatesGridable,
  StripoPrebuiltSimpleTemplatesGridable,
  StripoPrebuiltTemplatesFilterServiceFactory,
  StripoPrebuiltSimpleTemplatesFilterServiceFactory,
  StripoTemplateTypeService,
  StripoTemplateFeatureRepository,
  StripoTemplateSeasonRepository,
  StripoTemplateIndustryRepository,
  StripoTemplateSeasonService,
  StripoTemplateFeatureService,
  StripoTemplateIndustryService,
  StripoPrebuiltTemplateService,
  StripoPrebuiltTemplateResolverService,
}

export type StripoServices = keyof typeof SERVICES

export const STRIPO_SERVICE_TYPES: Record<StripoServices, symbol> = makeServicesTypes<StripoServices>(
  enumKeysToArray<StripoServices>(SERVICES),
)
